import { defineComponent as i, openBlock as m, createBlock as s, unref as f, mergeProps as b, withCtx as n, renderSlot as o } from "vue";
import "./ghl-ui.es335.js";
import c from "./ghl-ui.es336.js";
const p = i({
  name: "UIInput"
}), y = i({
  ...p,
  props: {
    modelValue: {
      type: Number
    },
    placeholder: String,
    readonly: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    precision: {
      type: Number,
      default: void 0
    },
    size: {
      type: String,
      default: "medium"
    },
    buttonPlacement: {
      type: String,
      default: void 0
    },
    showButton: {
      type: Boolean,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    min: {
      type: Number,
      default: void 0
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { emit: u }) {
    const d = u;
    function r(t) {
      d("update:modelValue", t);
    }
    return (t, l) => (m(), s(f(c), b({
      id: e.id,
      max: e.max,
      min: e.min,
      "button-placement": e.buttonPlacement,
      "show-button": e.showButton,
      precision: e.precision,
      disabled: e.disabled,
      size: e.size,
      readonly: e.readonly,
      value: e.modelValue,
      "onUpdate:value": r,
      placeholder: e.placeholder,
      clearable: e.clearable,
      loading: e.loading
    }, t.$attrs, {
      class: [e.loading ? "" : "hide-loader", "hl-input-number font-sans"],
      onFocus: l[0] || (l[0] = (a) => t.$emit("focus", a)),
      onBlur: l[1] || (l[1] = (a) => t.$emit("blur", a))
    }), {
      prefix: n(() => [
        o(t.$slots, "prefix")
      ]),
      suffix: n(() => [
        o(t.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["id", "max", "min", "button-placement", "show-button", "precision", "disabled", "size", "readonly", "value", "placeholder", "clearable", "loading", "class"]));
  }
}), v = y;
export {
  v as default
};
